export default {"src":"/_next/static/media/rr.b10edb66.svg","height":174,"width":320,"blurWidth":0,"blurHeight":0};